import React from 'react';
import { ProcessedTourOperator, ProcessedTripItinerary } from '../contentfulModel';
import {getTickIcon, renderRichText, RichTextNode} from "../utils.tsx";

interface HotelsTabProps {
    tourPackage: ProcessedTripItinerary;
    operatorColor: string;
    isMobile?: boolean;
    tourOperator: ProcessedTourOperator;
}




export const HotelsTab: React.FC<HotelsTabProps> = ({ tourPackage, operatorColor, isMobile, tourOperator }) => {

    const renderHotelGroups = (hotels: any[]) => {

        //iterate over hierarchy of hotels
        return hotels.map(
            (hotelGroup: any, index: number) => {
                return (
                    <div key={index} className="flex flex-col gap-2 w-full">
                        <div className="text-[12pt] font-bold text-start mb-2 pb-1" style={{
                            color: tourOperator.primaryColor || "#000000",
                            borderBottom: `1pt solid ${tourOperator.primaryColor || "#000000"}`,
                        }}>{hotelGroup.category}</div>
                        <div className="grid grid-cols-2 gap-x-10 gap-y-5 w-full">
                            {hotelGroup.cities.map((city) => (
                                <div key={city.name} className="flex flex-col">
                                    <div className="uppercase text-[12pt] font-bold text-start text-[#1A1A1A]">{city.name}</div>
                                    <div className="">
                                        {city.hotels.map((hotel: string, hotelIndex: number) => (
                                            <div key={hotelIndex} className="uppercase text-[8pt] text-start   text-[#1A1A1A]">{hotel}</div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            }
        )
        //iterate over keys values


    }


    return (
        <div className="flex flex-col md:flex-row w-full h-full overflow-auto">
            {/* Mobile: Content below image, Desktop: Content on left */}
            <div className="order-last md:order-first w-full md:w-[50%] flex flex-col">
                <div
                    id="obsContainer"
                    className="w-full bg-[#F7F6F2] flex-grow p-4 md:p-8 text-left md:pt-16 md:px-[70px]"
                >
                    <div className="mb-4">
                        <div className="text-md uppercase md:text-xl md:font-medium mb-1 md:pt-12">
                            {tourPackage.category}
                        </div>
                        <h2 className="text-xl md:text-2xl font-semibold md:font-black mb-1">
                            {tourPackage.name}
                        </h2>
                        {tourPackage.subtitle && (
                            <p className="text-lg font-normal md:font-semibold">
                                {tourPackage.subtitle}
                            </p>
                        )}
                    </div>

                    <div className="mt-6  mb-16 overflow-y-scroll">
                        <div
                            className=" h-full flex flex-col gap-[45px] gap-y-[20px] mt-0 w-full flex-wrap justify-start items-start content-start">
                            {renderHotelGroups(tourPackage.hotels)}
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile: Image on top, Desktop: Image on right */}
            <div className="order-first md:order-last w-full md:w-[70%] h-[200px] md:h-full">
                <div className="h-full relative">
                    <img
                        src={tourPackage.termsAndPricing?.observationImage?.file ||
                            tourPackage.mainImage?.file || ''}
                        alt="Observaciones"
                        className="w-full h-full object-cover rounded-b-2xl md:rounded-r-none md:rounded-l-2xl"
                    />
                    <img
                        src={tourOperator.logoContrast?.file || ''}
                        className="w-40 absolute hidden md:block bottom-4 right-4"
                        alt={tourOperator.name}
                    />
                </div>
            </div>
        </div>
    );
};
